$(document).on('turbolinks:load', function(){
    var current = location.pathname;
    $('#nav div').each(function(){
        var $this = $(this);
        var $this_a = $this.children('a');
        // if the current path is like this link, make it active
        if($this_a.attr('href') == current){            
            $this_a.addClass('active-nav-link');
            $this.addClass('active-nav-item')
        }
        if($this_a.attr('href') == '/' && current == '/dashboard'){   
            $this_a.addClass('active-nav-link');
            $this.addClass('active-nav-item')
        }
    })

    $("div.dashboard-item").click(function(){
        var bar = $(this).next("div").find('div.progress-bar');
        var width = ((parseInt(bar[0].ariaValueNow)/parseInt(bar[0].ariaValueMax))*100) + "%";
        bar.css("width", width);
    });
    $("button.details").click(function(){
        var isActive = $(this).hasClass('active');
        if(!isActive){
            $("button.schedule").removeClass("active");
            $("button.details").addClass("active");

            $("div.payout-schedule").hide();
            $("div.investment-details").show();
        }
    });
    $("button.schedule").click(function(){
        var isActive = $(this).hasClass('active');
        if(!isActive){
            $("button.details").removeClass("btn-active");
            $("button.schedule").addClass("btn-active");

            $("div.investment-details").hide();
            $("div.payout-schedule").show();
        }
    });
});